import React from 'react'
import { styled } from '@mui/material/styles'
import { Box, Button, AppBar } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '../Typography/Typography'
import ThemeConfig from '../../theme/ThemeConfig'

const PREFIX = 'DialogHeader'

const classes = {
  appBar: `${PREFIX}-appBar`,
  typography: `${PREFIX}-typography`,
  button: `${PREFIX}-button`,
}

const StyledAppBar = styled(AppBar)(() => ({
  [`&.${classes.appBar}`]: {
    position: 'relative',
    boxShadow: 'none',
    backgroundColor: ThemeConfig.palette.background.appBar,
  },

  [`& .${classes.typography}`]: {
    backgroundColor: ThemeConfig.palette.background.appBar,
    padding: '25px 0px 25px 25px',
  },

  [`& .${classes.button}`]: {
    padding: '25px',
  },
}))

const DialogHeader = props => {
  const { title, onClose } = props

  return (
    <StyledAppBar classes={{ root: classes.appBar }}>
      <Box display="flex" flexWrap="nowrap">
        <Box flexGrow={1}>
          <Typography
            variant="h6"
            color="inherit"
            classes={{ root: classes.typography }}
            id="dialog-title"
          >
            {title}
          </Typography>
        </Box>
        <Box flexShrink={1}>
          <Button
            aria-label="Close"
            classes={{ root: classes.button }}
            onClick={onClose}
          >
            <CloseIcon style={{ color: '#fff' }} />
          </Button>
        </Box>
      </Box>
    </StyledAppBar>
  )
}

export default DialogHeader
